import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleStatusModel from "../../models/lab/SampleStatusModel";

/**
 * SampleStatus collection
 */
export default class SampleStatusCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return SampleStatusModel;
  }

}
